export default $axios => ({
    getRegions(params) {
        return $axios({
            method: 'GET',
            url: `/base/region/`,
            params: params
        });
    },
    getSectors(params) {
        return $axios({
            method: 'GET',
            url: `/base/sector/`,
            params: params
        });
    },
    getLocations(params) {
        return $axios({
            method: 'GET',
            url: `/base/locality`,
            params: params
        });
    },
    getAddressDataByLocality(params) {
        return $axios({
            method: 'GET',
            url: `/base/address`,
            params: params
        });
    }
});
